var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hide-for-group-options" },
    _vm._l(_vm.options, function (option, index) {
      return _c(
        "div",
        {
          key: index,
          class: _vm.value.includes(option.value)
            ? "active hide-for-group-badge"
            : "hide-for-group-badge",
        },
        [
          _vm.toggleVisibilityUrl &&
          !_vm.mandatoryHideForGroup.includes(option.value)
            ? _c(
                "span",
                {
                  staticClass: "change-visibility",
                  on: {
                    click: function ($event) {
                      return _vm.changeVisibility(option.value)
                    },
                  },
                },
                [_vm._v("\n            " + _vm._s(option.text) + "\n        ")]
              )
            : _vm.isToggleFleetManagerVisibilityButton(option.value)
            ? _c(
                "span",
                {
                  staticClass: "change-visibility",
                  on: { click: _vm.emitFleetManagerVisibilityToggled },
                },
                [_vm._v("\n            " + _vm._s(option.text) + "\n        ")]
              )
            : _c("span", [_vm._v(_vm._s(option.text))]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }